export default __webpack_public_path__ + "static/media/radio-big.9b9dad7e.jpg";